import { useState } from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import { scrollToId } from "@/lib/lenis";

// Phones: one swipeable row instead of a long vertical stack. Tablets/desktop: the regular grid passed in `desktop`.
export const railTrack = "flex gap-4 overflow-x-auto snap-x snap-mandatory -mx-5 px-5 pb-3 no-scrollbar items-start md:mx-0 md:px-0 md:pb-0 md:overflow-visible md:snap-none";
export const railItem = "shrink-0 w-[80vw] max-w-[340px] snap-start md:w-auto md:max-w-none";

export const SwipeHint = ({ count, testid }) => (
  count > 1 ? (
    <p data-testid={testid} className="md:hidden -mt-4 mb-4 flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-zinc-400">
      SWIPE <ArrowRight size={12} className="text-[#F5A524] nudge-x" /> {String(count).padStart(2, "0")} ITEMS
    </p>
  ) : null
);

// Desktop-only cap: items past `limit` are hidden on md+ until "show all" is pressed; "show less" folds them back (phones swipe through everything).
export const useCap = (total, limit) => {
  const [open, setOpen] = useState(false);
  return { hidden: (i) => (!open && i >= limit ? "md:hidden" : ""), needed: total > limit, open, setOpen };
};

export const ShowAll = ({ cap, total, testid, anchor }) => (
  cap.needed ? (
    <button type="button" data-testid={testid} aria-expanded={cap.open}
      onClick={() => { if (cap.open) scrollToId(anchor); cap.setOpen(!cap.open); }}
      className="hidden md:flex mx-auto mt-10 items-center gap-2 clip-tab bg-[#12131A] border border-[#F5A524]/40 px-6 py-3 font-mono text-xs tracking-[0.25em] text-[#F5A524] hover:bg-[#F5A524] hover:text-black transition-colors">
      {cap.open ? "SHOW LESS" : `SHOW ALL ${total}`} <ChevronDown size={14} className={`transition-transform duration-300 ${cap.open ? "rotate-180" : ""}`} />
    </button>
  ) : null
);
